@import "../../../theme/global";
/**
* @prop --lar-push-button-size: Push Button size
* @prop --lar-push-button-size-small: Push Button font size
*/

$button-size:           var(--lar-push-button-size, 4rem) !default;
$button-size-small:     var(--lar-push-button-size-small, 2rem) !default;

lar-button {
  width: $button-size;
  height: $button-size;
  line-height: $button-size;
  --lar-button-border-radius: 50%;
  --lar-button-border-radius-small: 50%;
  --lar-push-button-padding-top: 0;
  --lar-push-button-padding-bottom: 0;
  --lar-push-button-padding-left: 0;
  --lar-push-button-padding-right: 0;
  position: relative;
  margin: 0 auto;
  lar-icon {
    --lar-icon-size-small: calc(#{$button-size} / 2.8);
    position: absolute;
    transform: translateX(-50%) translateY(-50%);
  }
}

lar-button.lar-button-small {
  width: $button-size-small;
  height: $button-size-small;
  line-height: $button-size-small;
  lar-icon {
    --lar-icon-size-small: calc(#{$button-size-small} / 2.8);
  }
}